import { render, staticRenderFns } from "./ProofAddForm.vue?vue&type=template&id=03fe3cde&scoped=true"
import script from "./ProofAddForm.vue?vue&type=script&lang=js"
export * from "./ProofAddForm.vue?vue&type=script&lang=js"
import style0 from "./ProofAddForm.vue?vue&type=style&index=0&id=03fe3cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe3cde",
  null
  
)

export default component.exports